import axios from 'axios'

export const getEntApp = async (primarymsisdn: string) => {
  const axiosUrl = '/businessSales/kiosk/entity'
  const { data } = await axios.post(`${axiosUrl}`, { primarymsisdn })
  return data
}

export const saveActivationDocument = async (request: Record<string, string>) => {
  const fetchUrl = '/businessSales/kiosk/activation/documents'
  return await axios.post(fetchUrl, request)
}

export const signActivationDocument = async (request: Record<string, string>) => {
  const fetchUrl = '/businessSales/kiosk/activation/signature'
  return await axios.post(fetchUrl, request)
}

export const savePortabilityDocument = async (request: Record<string, any>) => {
  const fetchUrl = '/businessSales/kiosk/portability/documents'
  return await axios.post(fetchUrl, request)
}

export const signPortabilityDocument = async (request: Record<string, string>) => {
  const fetchUrl = '/businessSales/kiosk/portability/signature'
  return await axios.post(fetchUrl, request)
}
